import { useSuspenseQuery } from '@apollo/client/react';

import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { SidebarMenuBadge } from '@/components/ui/sidebar';
import { AppRequestsDocument } from 'src/graphql/actions/appRequests/appRequests.query';
import { withSuspense } from 'src/hoc';
import { AppRequestsKindEnum } from 'src/graphql/schema';

import { useVendorRequests } from '../model/VendorRequestsContext';
import { VendorRequestsFilter } from '../model/types';

import { VendorRequestsSidenavSkeleton } from './VendorRequestsSidenavSkeleton';

const SIDENAV_ITEMS: { filter: VendorRequestsFilter; label: string }[] = [
  { filter: 'received', label: 'Received' },
  { filter: 'sent', label: 'Sent' },
  { filter: 'declined', label: 'Declined' },
];

const VendorRequestsSidenavComponent = () => {
  const { filter, setFilter } = useVendorRequests();

  const { data: receivedData } = useSuspenseQuery(AppRequestsDocument, {
    variables: { kind: AppRequestsKindEnum.Received, perPage: 0 },
  });
  const { data: sentData } = useSuspenseQuery(AppRequestsDocument, {
    variables: { kind: AppRequestsKindEnum.Sent, perPage: 0 },
  });
  const { data: declinedData } = useSuspenseQuery(AppRequestsDocument, {
    variables: { kind: AppRequestsKindEnum.Declined, perPage: 0 },
  });

  const counts: Record<VendorRequestsFilter, number> = {
    received: receivedData.appRequests.nodesCount,
    sent: sentData.appRequests.nodesCount,
    declined: declinedData.appRequests.nodesCount,
  };

  return (
    <nav className="space-y-0.5 lg:sticky lg:top-0">
      <ul className="grid grid-cols-3 gap-1 lg:block">
        {SIDENAV_ITEMS.map((item) => {
          const isActive = item.filter === filter;

          return (
            <li key={item.filter} className="relative">
              <Button
                variant="ghost"
                onClick={() => setFilter(item.filter)}
                className={cn(
                  'justify-between text-left text-muted-foreground w-full',
                  isActive &&
                    'bg-[color-mix(in_srgb,var(--color-accent-software-escrow)_6%,#fff)] text-accent-software-escrow',
                )}
              >
                {item.label}
                <SidebarMenuBadge
                  className={cn(
                    'rounded-full text-2xs font-bold bg-muted text-muted-foreground',
                    isActive && 'text-accent-software-escrow',
                  )}
                >
                  {counts[item.filter]}
                </SidebarMenuBadge>
              </Button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export const VendorRequestsSidenav = withSuspense(VendorRequestsSidenavComponent, VendorRequestsSidenavSkeleton);
